// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// // SETUP COLORS
// const GREY = {
//   0: '#FFFFFF',
//   100: '#F9FAFB',
//   200: '#F4F6F8',
//   300: '#DFE3E8',
//   400: '#C4CDD5',
//   500: '#919EAB',
//   600: '#637381',
//   700: '#454F5B',
//   800: '#212B36',
//   900: '#161C24',
// };

// const PRIMARY = {
//   lighter: '#D1E9FC',
//   light: '#76B0F1',
//   main: '#2065D1',
//   dark: '#103996',
//   darker: '#061B64',
//   contrastText: '#fff',
// };

// const SECONDARY = {
//   lighter: '#D6E4FF',
//   light: '#84A9FF',
//   main: '#3366FF',
//   dark: '#1939B7',
//   darker: '#091A7A',
//   contrastText: '#fff',
// };

// const INFO = {
//   lighter: '#D0F2FF',
//   light: '#74CAFF',
//   main: '#1890FF',
//   dark: '#0C53B7',
//   darker: '#04297A',
//   contrastText: '#fff',
// };

// const SUCCESS = {
//   lighter: '#E9FCD4',
//   light: '#AAF27F',
//   main: '#54D62C',
//   dark: '#229A16',
//   darker: '#08660D',
//   contrastText: GREY[800],
// };

// const WARNING = {
//   lighter: '#FFF7CD',
//   light: '#FFE16A',
//   main: '#FFC107',
//   dark: '#B78103',
//   darker: '#7A4F01',
//   contrastText: GREY[800],
// };

// const ERROR = {
//   lighter: '#FFE7D9',
//   light: '#FFA48D',
//   main: '#FF4842',
//   dark: '#B72136',
//   darker: '#7A0C2E',
//   contrastText: '#fff',
// };

// const palette = {
//   common: { black: '#000', white: '#fff' },
//   primary: PRIMARY,
//   secondary: SECONDARY,
//   info: INFO,
//   success: SUCCESS,
//   warning: WARNING,
//   error: ERROR,
//   grey: GREY,
//   divider: alpha(GREY[500], 0.24),
//   text: {
//     primary: GREY[800],
//     secondary: GREY[600],
//     disabled: GREY[500],
//   },
//   background: {
//     paper: '#fff',
//     default: GREY[100],
//     neutral: GREY[200],
//   },
//   action: {
//     active: GREY[600],
//     hover: alpha(GREY[500], 0.08),
//     selected: alpha(GREY[500], 0.16),
//     disabled: alpha(GREY[500], 0.8),
//     disabledBackground: alpha(GREY[500], 0.24),
//     focus: alpha(GREY[500], 0.24),
//     hoverOpacity: 0.08,
//     disabledOpacity: 0.48,
//   },
// };

// export default palette;


// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// // SETUP COLORS
// const GREY = {
//   0: '#FFFFFF',
//   100: '#F9FAFB',
//   200: '#F4F6F8',
//   300: '#DFE3E8',
//   400: '#C4CDD5',
//   500: '#919EAB',
//   600: '#637381',
//   700: '#454F5B',
//   800: '#212B36',
//   900: '#161C24',
// };

// const PRIMARY = {
//   lighter: '#C3FDB8',
//   light: '#68D391',
//   main: '#059669',
//   dark: '#047857',
//   darker: '#024B38',
//   contrastText: '#fff',
// };

// const SECONDARY = {
//   lighter: '#D6F6FF',
//   light: '#80D6FF',
//   main: '#00B4D8',
//   dark: '#0083B0',
//   darker: '#005C7A',
//   contrastText: '#fff',
// };

// const INFO = {
//   lighter: '#B5EAEA',
//   light: '#5CD6D6',
//   main: '#00B8B8',
//   dark: '#008080',
//   darker: '#004C4C',
//   contrastText: '#fff',
// };

// const SUCCESS = {
//   lighter: '#E4FEE4',
//   light: '#9AE6B4',
//   main: '#48BB78',
//   dark: '#2F855A',
//   darker: '#22543D',
//   contrastText: GREY[800],
// };

// const WARNING = {
//   lighter: '#FFEECC',
//   light: '#FFC107',
//   main: '#FFA500',
//   dark: '#B78103',
//   darker: '#7A4F01',
//   contrastText: GREY[800],
// };

// const ERROR = {
//   lighter: '#FFE7D9',
//   light: '#FFA48D',
//   main: '#FF4842',
//   dark: '#B72136',
//   darker: '#7A0C2E',
//   contrastText: '#fff',
// };

// const palette = {
//   common: { black: '#000', white: '#fff' },
//   primary: PRIMARY,
//   secondary: SECONDARY,
//   info: INFO,
//   success: SUCCESS,
//   warning: WARNING,
//   error: ERROR,
//   grey: GREY,
//   divider: alpha(GREY[500], 0.24),
//   text: {
//     primary: GREY[800],
//     secondary: GREY[600],
//     disabled: GREY[500],
//   },
//   background: {
//     paper: '#fff',
//     default: GREY[100],
//     neutral: GREY[200],
//   },
//   action: {
//     active: GREY[600],
//     hover: alpha(GREY[500], 0.08),
//     selected: alpha(GREY[500], 0.16),
//     disabled: alpha(GREY[500], 0.8),
//     disabledBackground: alpha(GREY[500], 0.24),
//     focus: alpha(GREY[500], 0.24),
//     hoverOpacity: 0.08,
//     disabledOpacity: 0.48,
//   },
// };

// export default palette;


// import { alpha } from '@mui/material/styles';

// // ----------------------------------------------------------------------

// // SETUP COLORS
// const GREEN = {
//   0: '#FFFFFF',
//   100: '#F9FAFB',
//   200: '#F4F6F8',
//   300: '#DFE3E8',
//   400: '#C4CDD5',
//   500: '#91C788',
//   600: '#63A05C',
//   700: '#457E40',
//   800: '#215026',
//   900: '#16401B',
// };

// const PRIMARY = {
//   lighter: '#D1FCCC',
//   light: '#76ECA8',
//   main: '#20C993',
//   dark: '#109A64',
//   darker: '#06613E',
//   contrastText: '#fff',
// };

// const SECONDARY = {
//   lighter: '#D6FFE4',
//   light: '#84FFB2',
//   main: '#33FF6E',
//   dark: '#19B749',
//   darker: '#097A2F',
//   contrastText: '#fff',
// };

// const INFO = {
//   lighter: '#CCF7FF',
//   light: '#6AE2FF',
//   main: '#0BB7FF',
//   dark: '#097A8A',
//   darker: '#05434E',
//   contrastText: '#fff',
// };

// const SUCCESS = {
//   lighter: '#E9FCD4',
//   light: '#AAFF7E',
//   main: '#3CD628',
//   dark: '#238D0F',
//   darker: '#0D5A03',
//   contrastText: GREEN[800],
// };

// const WARNING = {
//   lighter: '#FFF7CC',
//   light: '#FFE069',
//   main: '#FFBE06',
//   dark: '#B77403',
//   darker: '#7A4601',
//   contrastText: GREEN[800],
// };

// const ERROR = {
//   lighter: '#FFE6D9',
//   light: '#FFA08D',
//   main: '#FF463E',
//   dark: '#B72131',
//   darker: '#7A0C27',
//   contrastText: '#fff',
// };

// const palette = {
//   common: { black: '#000', white: '#fff' },
//   primary: PRIMARY,
//   secondary: SECONDARY,
//   info: INFO,
//   success: SUCCESS,
//   warning: WARNING,
//   error: ERROR,
//   grey: GREEN,
//   divider: alpha(GREEN[500], 0.24),
//   text: {
//     primary: GREEN[800],
//     secondary: GREEN[600],
//     disabled: GREEN[500],
//   },
//   background: {
//     paper: '#fff',
//     default: GREEN[100],
//     neutral: GREEN[200],
//   },
//   action: {
//     active: GREEN[600],
//     hover: alpha(GREEN[500], 0.08),
//     selected: alpha(GREEN[500], 0.16),
//     disabled: alpha(GREEN[500], 0.8),
//     disabledBackground: alpha(GREEN[500], 0.24),
//     focus: alpha(GREEN[500], 0.24),
//     hoverOpacity: 0.08,
//     disabledOpacity: 0.48,
//   },
// };

// export default palette;


import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const BROWN = {
  0: '#FFFFFF',
  100: '#FAF5F2',
  200: '#F3ECE5',
  300: '#E1CFC2',
  400: '#C2A797',
  500: '#8E6D5F',
  600: '#634D3A',
  700: '#402F1C',
  800: '#20150C',
  900: '#100800',
};

const PRIMARY = {
  lighter: '#F9D4B7',
  light: '#D68E60',
  main: '#A43D0C',
  dark: '#6E2303',
  darker: '#3A1100',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#FFD9B2',
  light: '#FFAA7F',
  main: '#FF7A4D',
  dark: '#B75133',
  darker: '#7A291A',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#F5DBD9',
  light: '#E0968E',
  main: '#B43F3F',
  dark: '#7F2222',
  darker: '#461010',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#F1ECC7',
  light: '#D6C87E',
  main: '#A49B3D',
  dark: '#6D6C1F',
  darker: '#3A3A08',
  contrastText: BROWN[800],
};

const WARNING = {
  lighter: '#FFF1B2',
  light: '#FFD97F',
  main: '#FFBF4D',
  dark: '#B78D33',
  darker: '#7A5A1A',
  contrastText: BROWN[800],
};

const ERROR = {
  lighter: '#F7D9D9',
  light: '#E38F8F',
  main: '#BF3D3D',
  dark: '#7F2323',
  darker: '#461010',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: BROWN,
  divider: alpha(BROWN[500], 0.24),
  text: {
    primary: BROWN[800],
    secondary: BROWN[600],
    disabled: BROWN[500],
  },
  background: {
    paper: '#fff',
    default: BROWN[100],
    neutral: BROWN[200],
  },
  action: {
    active: BROWN[600],
    hover: alpha(BROWN[500], 0.08),
    selected: alpha(BROWN[500], 0.16),
    disabled: alpha(BROWN[500], 0.8),
    disabledBackground: alpha(BROWN[500], 0.24),
    focus: alpha(BROWN[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;